import { useSelector } from 'react-redux'

import { THUNDER_ICON } from 'consts/mediaUrls'
import { T } from 'consts/translationKeys'
import { creditsSelectors } from 'store/features/credits/selectors'
import { translate } from 'utils/translations'
import * as Styled from './styled'
import { useOpenUpgradePopup } from 'hooks/useOpenUpgradePopup'
import { REF_LINKS } from 'consts/refLinks'

const RefillButton = () => {
  const userCredits = useSelector(creditsSelectors.userCredits)
  const openUpgradePopup = useOpenUpgradePopup()

  const buttonText =
    userCredits === 0
      ? translate(T.REFILL_LABEL)
      : translate(T.AI_CREDITS_LABEL)

  return (
    <Styled.RefillButton
      onClick={() =>
        openUpgradePopup({ ref: REF_LINKS.V_EDITOR_HEADER_BUTTON })
      }
    >
      <img src={THUNDER_ICON} alt="refill" />
      <span className="credits-count">{userCredits}</span>
      <span className="credits-label">{buttonText}</span>
    </Styled.RefillButton>
  )
}

export default RefillButton
